import BaseStrategy from './BaseStrategy';

const SAML = () => <BaseStrategy authStep="saml" />;

export default SAML;
